module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_7016.ebda049e.png";